/* istanbul ignore file */
import { Show } from 'framework/show';
import { ShowSection, SectionRow, ShowPageLayout } from 'framework/ui/layout';
import ViewSkillBasedQueuePageMenu from 'domain/gpo/skillBasedQueue/Show/ViewSkillBasedQueuePageMenu';
import SkillBasedQueueEntityHeader from 'domain/gpo/skillBasedQueue/shared/SkillBasedQueueEntityHeader';
import SingleSkillBasedQueueBreadcrumbs from 'domain/gpo/skillBasedQueue/shared/SingleSkillBasedQueueBreadcrumbs';
import { TextField } from 'framework/ui/field';
import useSkillBasedQueueService, {
  UPDATE_SKILL_BASED_QUEUE,
} from 'domain/gpo/skillBasedQueue/shared/skillBasedQueueService';
import { useSkillBasedQueueId } from 'domain/gpo/skillBasedQueue/skillBasedQueueRoute';
import DeleteSkillBasedQueueButton from 'domain/gpo/skillBasedQueue/shared/button/DeleteSkillBasedQueueButton';
import EditSkillBasedQueueButton from '../shared/button/EditSkillBasedQueueButton';
import { BudgetLinkWithNameLoadingField } from 'domain/shared/budget';

const ViewSkillBasedQueue = () => {
  const id = useSkillBasedQueueId();
  const { getById } = useSkillBasedQueueService();

  return (
    <Show getDataMethod={() => getById(id)}>
      <ShowPageLayout
        headerButtons={[
          <EditSkillBasedQueueButton
            key="edit-skill-based-queue"
            source="id"
            icon={<i className="fa fa-edit" />}
            permissionToCheck={UPDATE_SKILL_BASED_QUEUE}
          />,
          <DeleteSkillBasedQueueButton key="delete-skill-based-queue" />,
        ]}
        menu={<ViewSkillBasedQueuePageMenu />}
        breadcrumbs={<SingleSkillBasedQueueBreadcrumbs />}
        entityHeader={<SkillBasedQueueEntityHeader />}
        hasSeparateSections
      >
        <ShowSection title="Skill based queue information">
          <SectionRow>
            <TextField label="Name" source="name" />
            <BudgetLinkWithNameLoadingField label="Default budget" source="defaultBudgetId" />
          </SectionRow>
        </ShowSection>
      </ShowPageLayout>
    </Show>
  );
};

export default ViewSkillBasedQueue;
